














import shortid from 'shortid';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Data, Series } from '../../models';
import DoughnutChartBaseWrapper from './DoughnutChartBaseWrapper.vue';

@Component({
	components: {
		DoughnutChartBaseWrapper
	}
})
export default class DoughnutChart extends Vue {
	@Prop() public title: string;
	@Prop() public data: Data;

	public reportId: string = '';

	public mounted() {
		this.reportId = shortid.generate();
	}
}
